import React from 'react'
import goAway1 from '../images/goAway1.jpg'
import './heroimg3style.css';
import styled, {keyframes} from 'styled-components';
import { Link } from 'react-router-dom';



const Heroimg3 = () => {


  return (
    
    <div>
        <div className='hero3'>
            <div className="mask1">
        <img className='Heroimage1' src={goAway1} alt="Heroimg" width={1500} height={1500} />
        <div>
        <div className='content1'>
            <Details>Go away</Details>
            <Detailed className='dets'>Listen now on Spotify</Detailed>
        <div>
        <Link to="https://open.spotify.com/track/6BAupTDP4elLAViFo0qnkk?si=c0dec5b5efcd46ff" target='_blank' className='butt btn position-absolute'>PLAY</Link>
        </div>
        </div>
        </div>
        </div>
        </div>
    </div>
  )
}
// frame 1
const Albumdetails = keyframes `
from {
  opacity: 0;
  transform: translateX(600px);
}
to {
  opacity: 1;
  transform: translateY(0px);
}
`
;
const Details = styled.h1`
animation-name: ${Albumdetails};
animation-duration: 4000ms;
animation-delay: 5000ms;
animation-iteration-count: 1;
`

//frame2
const Albumdesc = keyframes `
from {
  opacity: 0;
  transform: translateX(-100px);
}
to {
  opacity: 1;
  transform: translateY(0px);
}
`
;
const Detailed = styled.h4`
animation-name: ${Albumdesc};
animation-duration: 4000ms;
animation-delay: 5000ms;
animation-iteration-count: 1;
`


export default Heroimg3